import type { MouseEventHandler } from 'react'

const PrevButton = (params: { onClick?: MouseEventHandler<HTMLButtonElement> } | undefined) => {
  return (
    <button className='button-pagination' onClick={params?.onClick}>
      <svg
        width='10'
        height='16'
        viewBox='0 0 10 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.000977159 8.00078L8.18304 0.000150241L10.001 1.77778L3.63686 8.00078L10.001 14.2225L8.18304 16.0001L0.000977159 8.00078Z'
          fill='#0076E3'
        />
      </svg>
    </button>
  )
}

export default PrevButton
